module.exports = __webpack_public_path__ + "img/logo-mini.029d72a3.svg";